<script setup>
const { mobile } = useDisplay();
const { role, authUser, hasHoldingsPerm, hasPerm, hasRole, logout } = useAuth();
const drawer = ref(!mobile.value);
const rail = ref(!mobile.value);

const navigation = [
  {
    title: "Amministrazione",
    prependIcon: "mdi-chart-box-outline",
    roles: [role.ADMINISTRATOR],
    items: [
      {
        title: "Campagne",
        prependIcon: "mdi-finance",
        to: "/campaigns/",
        // perms: ["campaigns.view_campaign"],
      },
      {
        title: "Offerte",
        prependIcon: "mdi-tag-outline",
        // perms: ["campaigns.view_offer"],
        to: "/offers/",
      },
      {
        title: "Prodotti",
        prependIcon: "mdi-shopping-outline",
        // perms: ["products.view_product"],
        to: "/products/",
      },
      {
        title: "Leads",
        prependIcon: "mdi-account-group-outline",
        // perms: ["wordfilia.view_lead"],
        to: "/leads/",
      },
      {
        title: "Negozi",
        prependIcon: "mdi-store-outline",
        // perms: ["store.view_store"],
        to: "/stores/",
      },
      {
        title: "Utenti",
        prependIcon: "mdi-account-outline",
        // perms: ["user.delete_gudoffersuser"],
        to: "/users/",
      },
    ],
  },
  {
    title: "Statistiche",
    prependIcon: "mdi-chart-bell-curve",
    roles: [role.ADMINISTRATOR, role.CALL_CENTER_ADMINISTRATOR],
    items: [
      {
        title: "Statistiche giacenze",
        prependIcon: "mdi-garage-variant-lock",
        // perms: ["orders.view_order"],
        to: "/stats/holdings/",
      },
      {
        title: "Statistiche ordini",
        prependIcon: "mdi-phone-outline",
        // perms: ["orders.view_order"],
        to: "/stats/orders/",
      },
    ],
  },
  {
    title: "Publisher",
    prependIcon: "mdi-briefcase-outline",
    roles: [role.ADMINISTRATOR],
    items: [
      {
        title: "Publisher",
        prependIcon: "mdi-briefcase-outline",
        // perms: ["publisher.view_publisher"],
        to: "/publishers/",
      },
      {
        title: "Team di publisher",
        prependIcon: "mdi-account-group-outline",
        // perms: ["publisher.view_team"],
        to: "/publishers/teams/",
      },
    ],
  },
  {
    title: "Magazzini",
    prependIcon: "mdi-warehouse",
    roles: [role.ADMINISTRATOR, role.WAREHOUSE_OPERATOR],
    items: [
      {
        title: "Magazzini",
        prependIcon: "mdi-warehouse",
        // perms: ["warehouse.view_warehouse"],
        to: "/wh/",
      },
      {
        title: "Gestione rimanenze",
        prependIcon: "mdi-package-variant-closed",
        // perms: ["warehouse.view_stock"],
        to: "/stocks/",
      },
    ],
  },
  {
    title: "Centralini",
    prependIcon: "mdi-domain",
    roles: [role.ADMINISTRATOR],
    items: [
      {
        title: "Centralini",
        prependIcon: "mdi-domain",
        // perms: ["call_center.view_callcenter"],
        to: "/cc/",
      },
      {
        title: "Team di operatori",
        prependIcon: "mdi-face-agent",
        // perms: ["call_center.view_team"],
        to: "/cc/teams/",
      },
    ],
  },
  {
    title: "Spedizioni",
    prependIcon: "mdi-truck-outline",
    roles: [role.ADMINISTRATOR],
    items: [
      {
        title: "Brokers",
        prependIcon: "mdi-truck-outline",
        // perms: ["couriers.view_broker"],
        to: "/brokers/",
      },
    ],
  },
];
</script>

<template>
  <v-navigation-drawer
    v-if="authUser"
    v-model="drawer"
    v-model:rail="rail"
    class="no-print"
    expand-on-hover
  >
    <template #prepend>
      <v-avatar class="tw-pl-3 tw-mt-2" size="38"
        ><span class="logo tw-font-semibold">_g</span></v-avatar
      >
    </template>
    <div v-if="authUser" id="main-navigation-drawer-main-section">
      <v-list open-strategy="single" color="primary" nav slim>
        <v-list-item title="Home" prepend-icon="mdi-home-outline" to="/" />
        <v-list-item
          v-if="
            hasRole(authUser, [
              role.ADMINISTRATOR,
              role.CALL_CENTER_OPERATOR,
              role.CALL_CENTER_TEAM_LEADER,
              role.WAREHOUSE_OPERATOR,
            ])
          "
          title="Ordini"
          prepend-icon="mdi-phone-outline"
          to="/orders/"
        />
        <v-list-item
          v-if="hasHoldingsPerm"
          title="Giacenze"
          prepend-icon="mdi-garage-variant-lock"
          to="/holdings/"
        />
        <v-list-item
          v-if="
            hasRole(authUser, [role.ADMINISTRATOR, role.WAREHOUSE_OPERATOR])
          "
          title="Documenti"
          prepend-icon="mdi-folder-search-outline"
          to="/files/"
        />
        <template v-for="nav in navigation" :key="nav.title">
          <v-list-group v-if="hasRole(authUser, nav?.roles)">
            <template #activator="{ props }">
              <v-list-item
                :title="nav.title"
                :prepend-icon="nav.prependIcon"
                v-bind="props"
              />
            </template>
            <template v-for="item in nav.items" :key="item.title">
              <v-list-item
                v-if="
                  hasRole(authUser, item?.roles) &&
                  hasPerm(authUser, item?.perms)
                "
                density="compact"
                :title="item.title"
                :to="item.to"
                :prepend-icon="item.prependIcon"
              />
            </template>
          </v-list-group>
        </template>
      </v-list>
    </div>
    <template v-if="authUser" #append>
      <v-list>
        <v-list-item>
          <template #prepend>
            <v-avatar>
              {{ authUser?.first_name?.at(0) ?? authUser.email.at(0) }}
            </v-avatar>
          </template>
          <template #title>
            {{ authUser.first_name }} {{ authUser.last_name }}
          </template>
          <template #subtitle>{{ authUser.email }}</template>
          <template #append>
            <v-btn icon="mdi-logout" variant="plain" @click="logout" />
          </template>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
  <v-app-bar
    id="main-navigation-bar"
    density="compact"
    :color="authUser ? 'white' : 'primary'"
    class="no-print"
    flat
  >
    <template v-if="mobile" #prepend>
      <v-app-bar-nav-icon
        v-if="mobile"
        color="primary"
        @click.stop="
          () => {
            drawer = !drawer;
          }
        "
      >
        <v-avatar size="35" color="primary"> G </v-avatar>
      </v-app-bar-nav-icon>
    </template>
  </v-app-bar>
</template>

<style>
:root {
  --indent-padding: 0;
}
.v-list-group__items .v-list-item {
  padding-inline-start: 10px !important;
}
.v-navigation-drawer--rail .v-list-item__overlay {
  width: 42px !important;
}
</style>
